import { forwardRef } from 'react'
import { Link, type LinkProps } from 'react-router-dom'
import { useLocaleNavigate } from '@/hooks/use-locale-navigate'

interface LocaleLinkProps extends Omit<LinkProps, 'to'> {
  to: string
}

/**
 * Drop-in replacement for React Router <Link> that automatically prepends the
 * current locale prefix. Always use this for internal navigation.
 * forwardRef required — Radix Slot (asChild) clones this and attaches a ref.
 */
export const LocaleLink = forwardRef<HTMLAnchorElement, LocaleLinkProps>(
  ({ to, ...props }, ref) => {
    const { buildPath } = useLocaleNavigate()
    return <Link ref={ref} to={buildPath(to)} {...props} />
  }
)
LocaleLink.displayName = 'LocaleLink'
